var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isLoading
        ? _c(
            "el-card",
            { staticClass: "border rounded p-3 d-flex align-items-center" },
            [
              _c("i", { staticClass: "el-icon-loading mr-2" }),
              _vm._v("\n        Carregando distribuidor...\n    ")
            ]
          )
        : !_vm.isLoading && _vm.distributor
        ? _c(
            "el-card",
            [
              _c(
                "el-page-header",
                { staticClass: "align-items-start", on: { back: _vm.goBack } },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex flex-wrap align-items-start justify-content-between mb-3",
                      attrs: { slot: "content" },
                      slot: "content"
                    },
                    [
                      _c("div", { staticClass: "d-flex flex-column" }, [
                        _c("h6", [_vm._v(_vm._s(_vm.distributor.nome))])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "success",
                                size: "mini",
                                plain: "",
                                disabled: _vm.isLoading
                              },
                              on: {
                                click: function($event) {
                                  return _vm.showLoginAs()
                                }
                              }
                            },
                            [
                              _vm.isLoading
                                ? _c("i", { staticClass: "el-icon-loading" })
                                : _c("i", {
                                    staticClass: "fas fa-sign-in-alt"
                                  }),
                              _vm._v(
                                "\n                        Logar como\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.isAuthorized
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "warning",
                                    size: "mini",
                                    plain: "",
                                    disabled: _vm.isLoading
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.dispatchChangePassword(
                                        _vm.scope.row.id
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm.isLoading
                                    ? _c("i", {
                                        staticClass: "el-icon-loading"
                                      })
                                    : _c("i", { staticClass: "fas fa-key" }),
                                  _vm._v(
                                    "\n                        Alterar senha\n                    "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 12 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-descriptions",
                        {
                          staticClass: "my-3",
                          attrs: {
                            title: "Informações",
                            column: 6,
                            size: "mini",
                            border: true
                          }
                        },
                        [
                          _c(
                            "el-descriptions-item",
                            { attrs: { span: 6 } },
                            [
                              _c("template", { slot: "label" }, [
                                _vm._v("Distribuidor")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-items-center justify-content-between"
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.distributor.nome))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "d-flex align-items-center"
                                    },
                                    [
                                      _c(
                                        "el-tag",
                                        {
                                          staticClass: "mr-2",
                                          attrs: { type: "info", size: "mini" }
                                        },
                                        [
                                          _vm._v(
                                            "#" + _vm._s(_vm.distributor.codigo)
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { size: "mini", circle: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.copyThis(
                                                _vm.distributor.codigo
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-document-copy"
                                          })
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "el-descriptions-item",
                            { attrs: { span: 2 } },
                            [
                              _c("template", { slot: "label" }, [
                                _vm._v("Classe")
                              ]),
                              _vm._v(" "),
                              _c("el-tag", { attrs: { size: "mini" } }, [
                                _vm._v(_vm._s(_vm.distributor.classe || "-"))
                              ])
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "el-descriptions-item",
                            { attrs: { span: 2 } },
                            [
                              _c("template", { slot: "label" }, [
                                _vm._v("Status")
                              ]),
                              _vm._v(" "),
                              _vm.distributor.status
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type:
                                          _vm.distributor.status.nome ===
                                          "Ativo"
                                            ? "success"
                                            : _vm.distributor.status.nome ==
                                              "Inativo"
                                            ? "warning"
                                            : "danger",
                                        size: "mini"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.distributor.status.nome) +
                                          "\n                        "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm.distributor.created_at.date
                            ? _c(
                                "el-descriptions-item",
                                { attrs: { span: 2 } },
                                [
                                  _c("template", { slot: "label" }, [
                                    _vm._v("Criado em")
                                  ]),
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.distributor.created_at.date) +
                                      "\n                    "
                                  )
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.distributor && _vm.distributor.pessoa_fisica
                            ? _c(
                                "el-descriptions-item",
                                { attrs: { span: 6 } },
                                [
                                  _c("template", { slot: "label" }, [
                                    _vm._v("CPF")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-items-center justify-content-between"
                                    },
                                    [
                                      _c(
                                        "div",
                                        [
                                          _vm.isLoading
                                            ? _c("el-skeleton")
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.distributor
                                                      .pessoa_fisica.cpf || "-"
                                                  )
                                                )
                                              ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.distributor.cpf
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "mini",
                                                circle: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.copyThis(
                                                    _vm.distributor
                                                      .pessoa_fisica.cpf
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-document-copy"
                                              })
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                2
                              )
                            : _vm.distributor && _vm.distributor.pessoa_juridica
                            ? _c(
                                "el-descriptions-item",
                                { attrs: { span: 6 } },
                                [
                                  _c("template", { slot: "label" }, [
                                    _vm._v("CNPJ")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-items-center justify-content-between"
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.distributor.pessoa_juridica
                                              .cnpj || "-"
                                          ) +
                                          "\n                            "
                                      ),
                                      _vm.distributor.pessoa_juridica.cnpj
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "mini",
                                                circle: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.copyThis(
                                                    _vm.distributor
                                                      .pessoa_juridica.cnpj
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-document-copy"
                                              })
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                2
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-descriptions",
                        {
                          staticClass: "my-3",
                          attrs: {
                            title: "Contatos",
                            column: 4,
                            size: "mini",
                            border: true
                          }
                        },
                        [
                          _c(
                            "el-descriptions-item",
                            { attrs: { span: 4 } },
                            [
                              _c("template", { slot: "label" }, [
                                _c("i", {
                                  attrs: { clsas: "fas fa-envelope" }
                                }),
                                _vm._v(
                                  "\n                            E-mail\n                        "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-items-center justify-content-between"
                                },
                                [
                                  _c(
                                    "el-tag",
                                    { attrs: { type: "info", size: "mini" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.distributor.email || "-")
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.distributor.email
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: { size: "mini", circle: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.copyThis(
                                                _vm.distributor.email
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-document-copy"
                                          })
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm.distributor && _vm.distributor.contatos.length > 0
                            ? _vm._l(_vm.distributor.contatos, function(
                                contact,
                                index
                              ) {
                                return _c(
                                  "el-descriptions-item",
                                  { key: contact.id, attrs: { span: 2 } },
                                  [
                                    _c("template", { slot: "label" }, [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            contact.telefone.tipo == "F"
                                              ? "Fixo"
                                              : "Celular"
                                          ) +
                                          "\n                        "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-items-center justify-content-between"
                                      },
                                      [
                                        _c(
                                          "el-tag",
                                          { attrs: { size: "mini" } },
                                          [
                                            _vm._v(
                                              "(" +
                                                _vm._s(contact.telefone.ddd) +
                                                ") " +
                                                _vm._s(contact.telefone.numero)
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { size: "mini", circle: "" },
                                            on: {
                                              click: function($event) {
                                                _vm.copyThis(
                                                  "(" +
                                                    contact.ddd +
                                                    ")$ {contact.numero}"
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-document-copy"
                                            })
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  2
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.distributor &&
                          _vm.distributor.endereco.endereco_formatado
                            ? _c(
                                "el-descriptions-item",
                                { attrs: { span: 4 } },
                                [
                                  _c("template", { slot: "label" }, [
                                    _vm._v("Endereço")
                                  ]),
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.distributor.endereco
                                          .endereco_formatado
                                      ) +
                                      "\n                    "
                                  )
                                ],
                                2
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tabs",
                {
                  attrs: { type: "border-card" },
                  model: {
                    value: _vm.activeName,
                    callback: function($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName"
                  }
                },
                [
                  _c("el-tab-pane", { attrs: { name: "first" } }, [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _c("i", { staticClass: "el-icon-folder" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml-1" }, [_vm._v("Anexos")])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "el-tag",
                          { staticClass: "mb-3", attrs: { type: "warning" } },
                          [
                            _c("i", { staticClass: "el-icon-warning-outline" }),
                            _vm._v(
                              " \n                        Este distribuidor já foi aprovado, atenção ao modificar anexos já existentes, o ideal é apenas a adição novos de arquivos.\n                    "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.getProspect != null
                          ? _c("Anexos", {
                              attrs: { prospect: _vm.getProspect }
                            })
                          : _c("el-empty", {
                              attrs: {
                                description:
                                  "Não existe um prospecto associado a este distribuidor"
                              }
                            })
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        : _c(
            "el-card",
            [
              _c("el-empty", {
                attrs: { description: "Distribuidor não encontrado" }
              })
            ],
            1
          ),
      _vm._v(" "),
      _c("DistribuidorChangePassword", { ref: "changePassword" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1df2fe52", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1df2fe52","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/distribuidor/Show.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1df2fe52","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/distribuidor/Show.vue
// module chunks = 2